import React, { Component } from 'react'
import { connect } from 'react-redux'
import './Header.css'
import { Conditionnal } from '../ImportAll'

// wave SVG généré avec : https://getwaves.io/?ref=producthunt
class Header extends Component {
    LeaveTunnel() {
        if (
            window.confirm(
                'Voulez-vous quitter le questionnaire? Vos données seront perdues.'
            )
        ) {
            window.location.replace(window.location.origin)
        }
    }

    render() {
        var logoCss = { backgroundImage: `url("logo-mec.png")` }
        if (this.props.url_logo) {
            logoCss = { backgroundImage: `url("` + this.props.url_logo + `")` }
        }
        return (
            <div className="Header">
                {/* Debut Barre du haut*/}

                <Conditionnal linked_data_id="cacher_header" isEmpty>
                    <div className="TopBar">
                        <div
                            className="mainLogo"
                            style={logoCss}
                            onClick={(e) => this.LeaveTunnel()}
                        />
                        <Conditionnal linked_data_id="user_id" isNotEmpty>
                            <Conditionnal
                                linked_data_id="user_id"
                                isNotEqualTo
                                targetDataValueCompare={-1}
                            >
                                <div className="rightName">
                                    Connecté : <br></br>
                                    {this.props.user_prenom}{' '}
                                    {this.props.user_nom}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                    </div>

                    <svg
                      className="topwave"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1440 100"
                      preserveAspectRatio="none"
                    >
                        <path
                          fill="#58B7B8"
                          fillOpacity="1"
                          d="M0,0L80,10.7C160,21,320,43,480,42.7C640,43,800,21,960,16C1120,11,1280,21,1360,26.7L1440,32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
                        ></path>
                    </svg>
                </Conditionnal>
                {/* Fin Barre du haut*/}

                {this.props.subTitle2 !== undefined &&
                this.props.subTitle2 !== '' ? (
                    <div className="background-haut">
                        <div>
                            <img
                                src="svg/house2.svg"
                                className="house"
                                alt="maison"
                            />
                            <img
                                src="svg/tree.svg"
                                className="tree-haut"
                                alt="arbre"
                            />
                        </div>
                        <div className="Container">
                            <div className="title-top">{this.props.title}</div>
                            <div className="title-bottom bold-font">
                                {this.props.subTitle}
                            </div>
                            <div className="title-bottom2">
                                {this.props.subTitle2}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="background">
                        <div>
                            <img
                                src="svg/house2.svg"
                                className="house"
                                alt="maison"
                            />
                            <img
                                src="svg/tree.svg"
                                className="tree"
                                alt="arbre"
                            />
                        </div>
                        <div className="Container">
                            <div className="title-top">{this.props.title}</div>
                            <div className="title-bottom bold-font">
                                {this.props.subTitle}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        url_logo: state.answer.tech_url_logo,
        user_prenom: state.answer.user_prenom,
        user_nom: state.answer.user_nom,
    }
}

export default connect(mapStateToProps)(Header)
